import { useParams, Navigate } from "react-router-dom";
import { Nav } from "@/components/site/Nav";
import { Footer } from "@/components/site/Footer";
import { Eyebrow } from "@/components/site/Reveal";
import { LEGAL, UPDATED } from "@/lib/legal";

export default function Legal() {
  const { slug } = useParams();
  const page = LEGAL[slug];
  if (!page) return <Navigate to="/" replace />;
  return (
    <main className="bg-[#091D18]" data-testid={`legal-page-${slug}`}>
      <Nav product={null} links={[]} />
      <section className="bg-[#F2EDE4] pb-24 pt-36 sm:pt-44">
        <div className="mx-auto max-w-3xl px-5 sm:px-8">
          <Eyebrow>gobbloo · Legal</Eyebrow>
          <h1 className="mt-5 font-display text-4xl font-bold tracking-tight text-[#091D18] sm:text-5xl" data-testid="legal-title">{page.title}</h1>
          <p className="mt-4 font-mono text-xs uppercase tracking-[0.2em] text-[#091D18]/60">Last updated: {UPDATED}</p>
          <div className="mt-12 space-y-10">
            {page.sections.map(([h, t], i) => (
              <section key={h} data-testid={`legal-section-${i}`}>
                <h2 className="font-display text-xl font-semibold text-[#091D18]">{h}</h2>
                <p className="mt-3 text-base leading-relaxed text-[#091D18]/80">{t}</p>
              </section>
            ))}
          </div>
        </div>
      </section>
      <Footer product={null} headline={<>Questions? <span className="font-serif italic font-normal text-[#D96B43]">Just ask.</span></>} />
    </main>
  );
}
